import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../../services/storage.service';
import { appConfig } from 'src/app/models/constants';
import { ApplicationInsightsService } from '../app-insights/app-insights.service';
import { ConfirmationService } from 'primeng/api';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private lastFailedRequest: HttpRequest<any> | null = null;
    private lastNextHandler: HttpHandler | null = null;
    constructor(private auth: MsalService,
        private storageService: StorageService,
        private appInsights: ApplicationInsightsService) {
        this.storageService.retry$.subscribe(() => {
            if (this.lastFailedRequest && this.lastNextHandler) {
                this.retryLastFailedRequest(this.lastNextHandler).subscribe();
            }
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.lastNextHandler = next;
        const scopes = ['user.read', 'profile'];
        let adtype = this.storageService.getWithDefaultPassphrase("GBL_LOG");
        let tenantId = this.storageService.decodeValue("clientCode");
        if (adtype == null || adtype == "null" ||
            adtype == undefined || adtype == "undefined" || adtype == "") {
            if (window.location.origin == appConfig.appConfigService?.myeybaseApiUrl) {
                this.storageService.setWithDefaultPassphrase("GBL_LOG", "MYEY");
                adtype = "MYEY";
            }
            else {
                this.storageService.setWithDefaultPassphrase("GBL_LOG", "EYAD");
                adtype = "EYAD";
            }
        }

        this.auth.getLogger().verbose('Url: ' + req.url + ' maps to scopes: ' + scopes);
        let storedToken = this.storageService.getSessionStorage('msal.idtoken');
        let tokenExpiry = this.storageService.getCookie('msal.idTokenExpiry');
        if (!scopes) {
            return next.handle(req);
        } else if (storedToken && tokenExpiry) {
            const header = {};
            if (tenantId != 'NA' && tenantId != '' && tenantId != 'undefined' && tenantId != undefined && tenantId != null && tenantId != 'null') {
                header["X-TENANT-ID"] = tenantId;
            }
            header['Authorization'] = storedToken ? `Bearer ${storedToken}` : '';
            header['ADTYPE'] = adtype;            
            const authReq = req.clone({ setHeaders: header });
            return next.handle(authReq).pipe(tap((evt: any) => {
                if (evt instanceof HttpResponse) {
                }
                if (appConfig.appConfigService?.appInsights?.enable) {
                    if (evt.status !== undefined) {
                        let protocol = window.location.protocol;
                        this.appInsights.trackTrace({
                            message: `${req.method},${req.url},${evt.status},${protocol},${req.body}`
                        })
                    }
                }
            }), catchError((err: any) => {
                if (appConfig.appConfigService?.appInsights?.enable) {
                    let protocol = window.location.protocol;
                    this.appInsights.trackTrace({
                        message: `${req.method},${req.url},${err?.status?.toString()},${protocol},${req.body}`
                    })
                }
                if (err.status === 401) {
                    alert("Session expired. Please login again.");
                    this.storageService.unAuthUserFound();
                }
                if (err.status === 409) {
                    this.lastFailedRequest = authReq;
                    if (!(localStorage.getItem('src') === 'external' && authReq.url.includes('/global/gateway/refresh/token'))) {
                        this.storageService.concurrFound.next(true);
                    }
                }
                return throwError(() => err);
            }));
        } else {
            this.storageService.unAuthUserFound();
        }
    }

    retryLastFailedRequest(next: HttpHandler): Observable<HttpEvent<any>> | null {
        if (this.lastFailedRequest) {
            const reqToRetry = this.lastFailedRequest;
            this.lastFailedRequest = null;
            return next.handle(reqToRetry);
        }
        return null;
    }
}
